import React, { useState } from "react";

import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

import { Box } from "@mui/material";

import CadernoLayout from "../../../Styles/layout/cadernoLayout";
import { CabecalhoEPForm } from "./cabecalhoEP";
import { QuantidadeEPForm } from "./quantidadeEP";
import { AplicacaoEPForm } from "./aplicacaoEP";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { IAplicacaoEP, ICabecalhoEP, IQuantidadeEP } from "../../../Interfaces/cadernos/caderno11";
import { FilterByData } from "../../../Func_genericas/filter_by_data";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
        },

        toolbars: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(2, 3),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },
        contents: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
    })
);


export default function RegGestaoEP() {
    const classes = useStyles();

    const [cabecalhos, setCabecalhos] = useState<ICabecalhoEP[]>([]);
    const [obj_Cabecalho, set_obj_Cabecalho] = useState<ICabecalhoEP>();

    const [rowsQuantidade, setRowsQuantidade] = useState<IQuantidadeEP[]>([]);
    const [obj_quantidade_EP, set_obj_quantidade_EP] = useState<IQuantidadeEP>();

    const [rowsAplicacoes, setRowsAplicacoes] = useState<IAplicacaoEP[]>([]);
    const [rowsAplicacoes_filtrada, setRowsAplicacoes_filtrada] = useState<IAplicacaoEP[]>([]);
    const [obj_aplicacaoEP, set_obj_aplicacaoEP] = useState<IAplicacaoEP>();



    return (
        <div className={classes.root}>
            <CadernoLayout title="11 - Registo de gestão de efluentes pecuários" />
            <main className={classes.contents}>
                <div className={classes.toolbars} />

                <Box width="80%" margin="auto">
                    <BeneficiarioNomeIdAlinhadoDireita />
                </Box>
                <FilterByData
                    listas={[
                        {
                            lista_original: rowsAplicacoes,
                            set_lista_filtrada: setRowsAplicacoes_filtrada,
                            campoData: "data",
                        },

                    ]}
                />
                <CabecalhoEPForm
                    obj_Cabecalho={obj_Cabecalho}
                    cabecalhos={cabecalhos}
                    setCabecalhos={setCabecalhos}
                    set_obj_Cabecalho={set_obj_Cabecalho}
                />

                <QuantidadeEPForm
                    obj_quantidade_EP={obj_quantidade_EP}
                    rows={rowsQuantidade}
                    set_obj_quantidade_EP={set_obj_quantidade_EP}
                    setRows={setRowsQuantidade}
                />

                <AplicacaoEPForm
                    obj_aplicacaoEP={obj_aplicacaoEP}
                    rows={rowsAplicacoes}
                    set_obj_aplicacaoEP={set_obj_aplicacaoEP}
                    setRows={setRowsAplicacoes} 
                    rows_filtrada={rowsAplicacoes_filtrada}
                    setRows_filtrada={setRowsAplicacoes_filtrada}
                    />

            </main>
        </div>
    );
}